<template>
  <div>
    <b-form inline>
      <div class="top_box">
        <div class="inner">
          <div class="left row">
            <div class="start">
              <label>{{ $t("filter.admin.start_time") }}</label>
              <input
                type="date"
                class="first"
                placeholder="2021-05-01"
                v-model="searchForm.startdate"
              />
              <input
                type="time"
                class="time"
                placeholder="18:00"
                v-model="searchForm.starttime"
              />
            </div>
            <div class="end">
              <label>{{ $t("filter.admin.end_time") }}</label>
              <input
                type="date"
                class="first"
                placeholder="2021-05-01"
                v-model="searchForm.enddate"
              />
              <input
                type="time"
                class="time"
                placeholder="18:00"
                v-model="searchForm.endtime"
              />
            </div>
            <div class="nameno">
              <label
                >{{ $t("filter.admin.location_name") }} /
                {{ $t("filter.admin.location_no") }}
              </label>
              <input
                type="text"
                placeholder=""
                class="first"
                v-model="searchForm.shopname"
              />
              <input type="text" placeholder="" v-model="searchForm.shopno" />
            </div>
            <div class="gameno">
              <label>{{ $t("filter.admin.game_no") }}</label>
              <input
                type="text"
                placeholder=""
                class="first w-100"
                v-model="searchForm.gameno"
              />
            </div>
            <div>
              <label>{{ $t("filter.admin.game_status") }}</label>
              <div class="form-check d-inline-block">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="flexCheck1"
                  v-model="searchForm.gamestatus0"
                  true-value="1"
                  false-value="0"
                  @click="check_status('gamestatus0')"
                />
                <label class="form-check-label" for="flexCheck1">{{
                  $t("filter.common.total")
                }}</label>
              </div>
              <div class="form-check d-inline-block">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="flexCheck2"
                  v-model="searchForm.gamestatus1"
                  true-value="1"
                  false-value="0"
                  @click="check_status('gamestatus1')"
                />
                <label class="form-check-label" for="flexCheck2">{{
                  $t("filter.common.playing")
                }}</label>
              </div>
              <div class="form-check d-inline-block mt-2 mt-sm-0">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="flexCheck3"
                  v-model="searchForm.gamestatus2"
                  true-value="1"
                  false-value="0"
                  @click="check_status('gamestatus2')"
                />
                <label class="form-check-label" for="flexCheck3">{{
                  $t("filter.common.terminated")
                }}</label>
              </div>
              <div class="form-check d-inline-block mt-2 mt-sm-0">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="flexCheck4"
                  v-model="searchForm.gamestatus3"
                  true-value="1"
                  false-value="0"
                  @click="check_status('gamestatus3')"
                />
                <label class="form-check-label" for="flexCheck4">{{
                  $t("filter.common.completed")
                }}</label>
              </div>
            </div>
          </div>

          <div class="right row">
            <div>
              <div>
                <label>{{ $t("filter.admin.course_type") }}</label>
                <select
                  class="form-select-lg d-inline-block"
                  v-model="searchForm.coursetype"
                >
                  <option value="">{{ $t("filter.admin.course_type") }}</option>
                  <option value="C">
                    {{ $t("filter.admin.golfcourse") }}
                  </option>
                  <option value="D">
                    {{ $t("filter.admin.drivingrange") }}
                  </option>
                </select>
              </div>
              <div>
                <label>{{ $t("title.common.course") }}</label>
                <input
                  type="text"
                  placeholder=""
                  v-model="searchForm.coursename"
                />
              </div>
              <div>
                <label>{{ $t("filter.admin.member_type") }}</label>
                <div class="form-check d-inline-block">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="membertype"
                    id="flexCheck5"
                    v-model="searchForm.membertype"
                    value="0"
                  />
                  <label class="form-check-label" for="flexCheck5">{{
                    $t("filter.common.total")
                  }}</label>
                </div>
                <div class="form-check d-inline-block">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="membertype"
                    id="flexCheck6"
                    v-model="searchForm.membertype"
                    value="1"
                  />
                  <label class="form-check-label" for="flexCheck6">{{
                    $t("filter.admin.guest")
                  }}</label>
                </div>
                <div class="form-check d-inline-block">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="membertype"
                    id="flexCheck7"
                    v-model="searchForm.membertype"
                    value="2"
                  />
                  <label class="form-check-label" for="flexCheck7">{{
                    $t("filter.admin.member")
                  }}</label>
                </div>
              </div>
            </div>
            <div>
              <div>
                <label
                  >{{ $t("filter.admin.member") }}
                  {{ $t("filter.common.name") }}</label
                >
                <input
                  type="text"
                  placeholder=""
                  v-model="searchForm.playername"
                />
              </div>
              <div>
                <label
                  >{{ $t("filter.admin.member") }}
                  {{ $t("filter.common.nickname") }}</label
                >
                <input
                  type="text"
                  placeholder=""
                  v-model="searchForm.playernickname"
                />
              </div>
              <div class="mb-0">
                <label>{{ $t("filter.admin.member_no") }}</label>
                <input
                  type="text"
                  placeholder=""
                  v-model="searchForm.playerno"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="btn-bottom-wrapper">
          <b-button
            size="xl"
            variant="outline-primary"
            :aria-label="$t('button.common.initialization')"
            @click="reset"
            >{{ $t("button.common.initialization") }}</b-button
          >
          <b-button
            size="xl"
            variant="primary"
            :aria-label="$t('button.common.search')"
            @click="search"
            >{{ $t("button.common.search") }}</b-button
          >
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
export default {
  name: "GameDataSearchLine",
  data() {
    return {
      searchForm: {
        startdate:
          this.$route.query.startdate ||
          (this.$store.state.searchData["GameDataView"] &&
            this.$store.state.searchData["GameDataView"].startdate) ||
          this.$dayjs().format("YYYY-MM-DD"),
        starttime:
          this.$route.query.starttime ||
          (this.$store.state.searchData["GameDataView"] &&
            this.$store.state.searchData["GameDataView"].starttime) ||
          this.$dayjs().format("00:00"),
        enddate:
          this.$route.query.enddate ||
          (this.$store.state.searchData["GameDataView"] &&
            this.$store.state.searchData["GameDataView"].enddate) ||
          this.$dayjs().format("YYYY-MM-DD"),
        endtime:
          this.$route.query.endtime ||
          (this.$store.state.searchData["GameDataView"] &&
            this.$store.state.searchData["GameDataView"].endtime) ||
          this.$dayjs().format("23:59"),
        gameno:
          this.$route.query.gameno ||
          (this.$store.state.searchData["GameDataView"] &&
            this.$store.state.searchData["GameDataView"].gameno) ||
          null,
        shopname:
          (this.$store.state.searchData["GameDataView"] &&
            this.$store.state.searchData["GameDataView"].shopname) ||
          null,
        shopno:
          (this.$store.state.searchData["GameDataView"] &&
            this.$store.state.searchData["GameDataView"].shopno) ||
          null,
        coursetype:
          (this.$store.state.searchData["GameDataView"] &&
            this.$store.state.searchData["GameDataView"].coursetype) ||
          "", //C: course, D: driving range
        coursename:
          (this.$store.state.searchData["GameDataView"] &&
            this.$store.state.searchData["GameDataView"].coursename) ||
          null,
        playername:
          (this.$store.state.searchData["GameDataView"] &&
            this.$store.state.searchData["GameDataView"].playername) ||
          null,
        playernickname:
          (this.$store.state.searchData["GameDataView"] &&
            this.$store.state.searchData["GameDataView"].playernickname) ||
          null,
        playerno:
          (this.$store.state.searchData["GameDataView"] &&
            this.$store.state.searchData["GameDataView"].playerno) ||
          null,
        gamestatus0:
          (this.$store.state.searchData["GameDataView"] &&
            this.$store.state.searchData["GameDataView"].gamestatus0) ||
          1, // 0,1
        gamestatus1:
          (this.$store.state.searchData["GameDataView"] &&
            this.$store.state.searchData["GameDataView"].gamestatus1) ||
          0, // 0,1
        gamestatus2:
          (this.$store.state.searchData["GameDataView"] &&
            this.$store.state.searchData["GameDataView"].gamestatus2) ||
          0, // 0,1
        gamestatus3:
          (this.$store.state.searchData["GameDataView"] &&
            this.$store.state.searchData["GameDataView"].gamestatus3) ||
          0, // 0,1
        membertype:
          (this.$store.state.searchData["GameDataView"] &&
            this.$store.state.searchData["GameDataView"].membertype) ||
          "", // 0: 전체, 1: 손님, 2: 회원
        pageno:
          this.$route.query.pageno ||
          (this.$store.state.searchData["GameDataView"] &&
            this.$store.state.searchData["GameDataView"].pageno) ||
          1,
      },
    };
  },
  methods: {
    search() {
      this.$emit("search", this.searchForm);
      this.$store.commit("setSearchData", {
        ["GameDataView"]: this.searchForm,
      });
    },
    check_status(val) {
      if (val=="gamestatus0") {
        this.searchForm.gamestatus0 = 1; // 0,1
        this.searchForm.gamestatus1 = 0; // 0,1
        this.searchForm.gamestatus2 = 0; // 0,1
        this.searchForm.gamestatus3 = 0; // 0,1
      } else {
        this.searchForm.gamestatus0 = 0; // 0,1
      }      
    },
    reset() {
      this.searchForm.startdate = this.$dayjs().format("YYYY-MM-DD");
      this.searchForm.starttime = this.$dayjs().format("00:00");
      this.searchForm.enddate = this.$dayjs().format("YYYY-MM-DD");
      this.searchForm.endtime = this.$dayjs().format("23:59");
      this.searchForm.gameno = null;
      this.searchForm.shopname = null;
      this.searchForm.shopno = null;
      this.searchForm.coursetype = ""; //C: course, D: driving range
      this.searchForm.coursename = null;
      this.searchForm.playername = null;
      this.searchForm.playernickname = null;
      this.searchForm.playerno = null;
      this.searchForm.gamestatus0 = 1; // 0,1
      this.searchForm.gamestatus1 = null; // 0,1
      this.searchForm.gamestatus2 = null; // 0,1
      this.searchForm.gamestatus3 = null; // 0,1
      this.searchForm.membertype = ""; // 0: 전체, 1: 손님, 2: 회원
    },
  },
};
</script>
